/** Admin routes: Super Admin (0) and Admin (1) */
export const isAdminRole = (role) => {
  if (role === null || role === undefined || role === "") return false;
  const n = Number(role);
  return n === 0 || n === 1;
};

/** Read-only loan viewer (4) */
export const isLoanAccountRole = (role) => {
  if (role === null || role === undefined || role === "") return false;
  return Number(role) === 4;
};

export const getAppBasePath = (role = localStorage.getItem("role")) => {
  if (isLoanAccountRole(role)) return "/loan-account";
  return isAdminRole(role) ? "/admin" : "/branch";
};

export const isSuperAdminRole = (role = localStorage.getItem("role")) => {
  if (role === null || role === undefined || role === "") return false;
  return Number(role) === 0;
};